import React, { useState } from 'react';

export default function Skills() {
  const [searchTerm, setSearchTerm] = useState('');
  
  // List of skills
  const skills = [
    { id: 1, name: 'PHP', className: 'php-skillcard' },
    { id: 2, name: 'JavaScript', className: 'js-skillcard' },
    { id: 3, name: 'HTML', className: 'html-skillcard' },
    { id: 4, name: 'CSS', className: 'css-skillcard' },
    { id: 5, name: 'React', className: 'react-skillcard' },
    { id: 6, name: 'MySQL', className: 'sql-skillcard' },
    { id: 7, name: 'Node', className: 'node-skillcard' },
    { id: 8, name: 'Python', className: 'python-skillcard' }
  ];

  // Filter skills based on search input
  const filteredSkills = skills.filter((skill) =>
    skill.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <>
      <div className="subheadings skills">
        <h1>Skills</h1>
        <div className="search-skill">
          <input
            type="text"
            className="form-control searchsubheadings searchskillinput"
            placeholder="Search..."
            aria-label="Search"
            aria-describedby="search"
            value={searchTerm}
            onChange={handleSearchChange} // Update search term on user input
          />
        </div>
        <div className="skill-collection">
          {filteredSkills.length > 0 ? (
            filteredSkills.map((skill) => (
              <div key={skill.id} className={`card skillcards ${skill.className}`}>
                <div className="skillcard-body">{skill.name}</div>
              </div>
            ))
          ) : (
            <div className="no-skill-section">No skills found</div> // Show message if no skill matches
          )}
        </div>
      </div>
    </>
  );
}
